module.exports = __webpack_public_path__ + "assets/img/12_149.f7c20d99.jpg";